var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#F1370F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66503 13.1868L5.94694 10.485C5.87099 10.4091 5.83301 10.3114 5.83301 10.192C5.83301 10.0727 5.87099 9.97504 5.94694 9.89908L6.54915 9.31315C6.62511 9.22634 6.72005 9.18294 6.83398 9.18294C6.94791 9.18294 7.04828 9.22634 7.13509 9.31315L8.958 11.1361L12.8642 7.22982C12.951 7.14301 13.0514 7.09961 13.1653 7.09961C13.2793 7.09961 13.3742 7.14301 13.4502 7.22982L14.0524 7.81575C14.1283 7.89171 14.1663 7.98936 14.1663 8.10872C14.1663 8.22808 14.1283 8.32573 14.0524 8.40169L9.25097 13.1868C9.17501 13.2736 9.07736 13.317 8.958 13.317C8.83864 13.317 8.74099 13.2736 8.66503 13.1868Z",
    fill: "#201E1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.60abb434d9fa8d104dcb5e7db5f32218.svg";
export { ForwardRef as ReactComponent };